import { CloudOff } from 'lucide-react';
import { useOffline } from '../stores/offline.js';

/**
 * « N en attente » : les écritures faites hors-ligne qui n'ont pas encore été rejouées.
 *
 * Le seul ajout d'UI de l'[ADR 0010](../../../docs/adr/0010-ecritures-offline-file-de-rejeu.md).
 * Il ne s'ouvre sur rien et ne propose pas de rejouer à la main — le rejeu est automatique.
 * Son unique rôle est de répondre à « est-ce que mon geste est parti ? », la question
 * qu'on se pose en sortant du métro. Invisible dès que la file est vide, donc invisible
 * la quasi-totalité du temps.
 */
export function PendingBadge({ variant }: { variant: 'icon' | 'row' }): React.ReactElement | null {
  const count = useOffline((s) => s.pending.length);
  if (count === 0) return null;

  const label = `${count} ${count > 1 ? 'actions en attente' : 'action en attente'} d’envoi`;
  const shown = count > 9 ? '9+' : count;

  if (variant === 'row') {
    return (
      <div role="status" aria-label={label} className="discret flex items-center gap-2 px-2 py-1">
        <CloudOff size={16} aria-hidden />
        <span className="flex-1">En attente</span>
        <span className="etiquette">{shown}</span>
      </div>
    );
  }

  return (
    <span role="status" aria-label={label} title={label} className="etiquette">
      <CloudOff size={14} aria-hidden />
      {shown}
    </span>
  );
}
